<template>
	<div>
		<div class="py-3 mt-3" v-if="benefits.length > 0">
      <div class="pb-3">
        <div class="row no-gutters">
          <div class="col-12 col-md-12">
            <p class="mb-0 font-bold text-20 body-2-2">{{$t('hotel.concierge.the-benefit-of-being')}} {{card_name}}</p>
          </div>
        </div>
      </div>
      <div class="pt-3 border-top">
        <div class="">
          <div class="row slim-grid-row mb-2" v-for="benefit in benefits">
            <div class="col-1">
              <img src="../../../../assets/img/icon/correct.png" class="position-relative" width="13" style="top: -2px">
            </div>
            <div class="col-11">
              <p class="mb-0 body-2-2 font-semibold text-14">{{benefit}}</p>
            </div>
          </div>
        </div>
    	</div>
    </div>
    <div class="w-100">
      <div id="Voucher" class="position-relative" style="top: -115px"></div>
      <p class="mb-0 body-1-1 text-18">{{$t('hotel.concierge.reward')}}</p>
      <p class="mb-3 pb-1 body-3-3-1">{{$t('hotel.concierge.contact-staff-to-claim-reward')}}</p>
      <loader v-if="is_load" />
      <template v-else>
        <div class="my-4" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
        <template v-else>
          <div class="w-100 mr-3 mb-3 rounded-6 border" v-for="data in reward_list">
            <div class="w-100" @click="reward_selected = data.id">
              <img :src="data.image_url" class="w-100 object-fit h-slide-reward cursor-pointer">
              <div class="py-2 px-3">
                <p class="mb-0 body-2-2 font-bold text-truncate text-16 cursor-pointer">{{data.name}}</p>
                <p class="mb-0 body-2 text-14 font-semibold d-inline-block">{{$t('hotel.concierge.valid-until')}} {{formatDate(data.end_date)}}</p>
              </div>
            </div>
          </div>  
        </template>
      </template>
    </div>

    <RewardDetail v-if="reward_selected != ''" :reward_id="reward_selected" @close="reward_selected = ''"></RewardDetail>
	</div>
</template>
<script>
  import {formatCurrency,formatDate} from '@/utils/index.js';
  import {mapGetters} from "vuex";
  import {get} from '@/services/index.js'
  import RewardDetail from '@/components/hotel/concierge/member/RewardDetail'

	export default{
		props: {
			benefits:{
				type: Array,
				default: () => []
			},
			card_name:{
				type: String,
				default: ''
			}
		},
    components:{
      RewardDetail
    },
		data(){
			return{
        is_load: false,
        error: '',
        reward_list: [],
        reward_selected: '',
			}
		},
    mounted(){
      this.loadRewardList()
    },
		methods:{
      ...mapGetters(['getMerchant']),
			formatDate(date){
        return formatDate(date);
      },
			toggleDetail(data){
        this.is_detail = data
      },
      loadRewardList(){
        this.is_load = true
        this.error = ''
        get("CONCIERGE","membership/reward-list",{
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.reward_list = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/member/RewardList.vue